// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FullPageSpinner_wrapper__1z156","transparent":"FullPageSpinner_transparent__1JrKg"};